export const RQ_GET_MTP_COMPLIANCE_API = {
  url:'dailyvisitattendee/mtp-compliance-report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};
